import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SideMenuState {
  isExpanded: boolean;
}

const initialState: SideMenuState = {
  isExpanded: true,
};

const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    toggleMenu: (state) => {
      state.isExpanded = !state.isExpanded;
    },
    setMenuExpanded: (state, action: PayloadAction<boolean>) => {
      state.isExpanded = action.payload;
    },
  },
});

// Exportamos las acciones
export const { toggleMenu, setMenuExpanded } = sideMenuSlice.actions;

// Exportamos el reducer por defecto
export default sideMenuSlice.reducer;
